import Vue from 'vue'
import axios from 'axios'
import {Message} from "element-ui";

let request = axios.create({
  baseURL: process.env.VUE_APP_REQUEST_BASE_URL,
  timeout: 20000,// request timeout
  withCredentials: true,
})

let casRequest = axios.create({
  baseURL: process.env.VUE_APP_CAS_REQUEST_BASE_URL,
  timeout: 5000,// request timeout
  withCredentials: true,
})

// 将axios添加到vue中
Vue.prototype.$axios = request

request.interceptors.request.use(config => {
  config.url = process.env.VUE_APP_REQUEST_URL_PREFIX + config.url
  return config
})

function responseSuccessHandler(response) {
  const res = response.data;
  if (res !== '' && res !== undefined && res.status !== 0 && res.status !== 302) {
    Message({
      message: res.msg || 'Error',
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(new Error(res))
  }
  return res
}

function responseFailureHandler(error) {
  Message({
    message: error || 'Error',
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
}

request.interceptors.response.use(
  responseSuccessHandler,
  responseFailureHandler
)

casRequest.interceptors.response.use(
  responseSuccessHandler,
  responseFailureHandler
)

export {casRequest}
export default request
